import { EventsInteractionsTracker } from './eventInteractionsTracker';
import { InteractionsLoggerV1 } from './interactionsLoggerV1';
import { InteractionsStatsigLogger } from './interactionsStatsigLogger';

export function startEventCardTracking() {
    const eventInteractionTracker = new EventsInteractionsTracker(document, [
        new InteractionsLoggerV1(),
        new InteractionsStatsigLogger(),
    ]);

    eventInteractionTracker.listen();
    eventInteractionTracker.track();
}
